
import { defineComponent } from 'vue';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';
import DriveCommentsSubpage from '../../../modules/drive/components/ViewSubpages/DriveCommentsSubpage.vue';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  components: {
    AppBottomPopUp,
    DriveCommentsSubpage,
  },
  setup() {
    const mainStore = useMainStore();

    function hidePopUp() {
      mainStore.BottomPopUpType = null;
    }

    return {
      hidePopUp,
    };
  },
});
